"use client";

type GenerateQueryParamsProps = {
  [key: string]: string | string[] | number | undefined;
};

export const generateQueryParams = (object: GenerateQueryParamsProps) => {
  const queryParams = Object.entries(object)
    .filter(([, value]) => value !== undefined && value !== null)
    .map(
      ([key, value]) =>
        `${encodeURIComponent(key)}=${encodeURIComponent(String(value))}`
    );

  return queryParams.length > 0 ? `?${queryParams.join("&")}` : "";
};

export const generateLineLink = (
  url: string,
  { title }: { title?: string }
) => {
  return `https://social-plugins.line.me/lineit/share${generateQueryParams({
    url,
    text: title,
  })}`;
};
export const generateRedditLink = (
  url: string,
  { title }: { title?: string }
) => {
  return `https://www.reddit.com/submit${generateQueryParams({ url, title })}`;
};

type GenerateWhatsAppLinkTypes = { title?: string; separator?: string };

export const generateWhatsAppLink = (
  url: string,
  { title, separator = " :: " }: GenerateWhatsAppLinkTypes
) => {
  return `https://api.whatsapp.com/send${generateQueryParams({
    text: title ? title + separator + url : url,
  })}`;
};

type GenerateTwitterLinkTypes = {
  title?: string;
  via?: string;
  hashTags?: string[];
  related?: string[];
};

export const generateTwitterLink = (
  url: string,
  { title, via, hashTags = [], related = [] }: GenerateTwitterLinkTypes
) => {
  return `https://x.com/intent/tweet${generateQueryParams({
    url,
    text: title,
    via,
    hashtags: hashTags.length > 0 ? hashTags.join(",") : undefined,
    related: related.length > 0 ? related.join(",") : undefined,
  })}`;
};

export const generateTelegramLink = (
  url: string,
  { title }: { title?: string }
) => {
  return `https://t.me/share/url${generateQueryParams({ url, title })}`;
};

export function generateFBLink(url: string, options?: { quote?: string; hashTags?: string[] }): string {
  const baseUrl = "https://www.facebook.com/sharer/sharer.php";
  const params = new URLSearchParams({
    u: url,
  });

  if (options?.quote) {
    params.append("quote", options.quote);
  }

  if (options?.hashTags) {
    const hashTagsString = options.hashTags.join(",");
    params.append("hashtag", hashTagsString);
  }

  return `${baseUrl}?${params.toString()}`;
}

type GeneratePinterestPinItLinkTypes = {
  media?: string;
  description?: string;
};

export const generatePinterestPinItLink = (
  url: string,
  { media, description }: GeneratePinterestPinItLinkTypes = {}
) => {
  return `https://pinterest.com/pin/create/button/${generateQueryParams({
    url,
    media,
    description
  })}`;
};